import React, { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';
import axios from 'axios';

const SignupForm = () => {
  const MAX_SPOTS = 12;
  const [availableSpots, setAvailableSpots] = useState(null);
  const [assignedGroup, setAssignedGroup] = useState('');
  const [subgroupName, setSubgroupName] = useState('');

  // Zgody (wymagane)
  const [consentBoth, setConsentBoth] = useState(false); // RODO + Polityka
  const [campRulesConsent, setCampRulesConsent] = useState(false);
  const [participantRulesConsent, setParticipantRulesConsent] = useState(false);

  // Modale (lokalne, tylko w SignupForm)
  const [showRodoModal, setShowRodoModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showCampRulesModal, setShowCampRulesModal] = useState(false);
  const [showParticipantRulesModal, setShowParticipantRulesModal] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    age: '',
    email: '',
    phone: '',
    option: '',
    confirmed: 'Nie',
  });

  const [personCount, setPersonCount] = useState(1);
  const [additionalPeople, setAdditionalPeople] = useState([]);

  useEffect(() => {
    fetch('https://opensheet.elk.sh/1zJYzeNrKT_oJCYoDpNzFyXNFnShthQISmrgNakNoFtU/Zgloszenia')
      .then((res) => res.json())
      .then((data) => {
        const confirmed = data.filter(row => row.Potwierdzony?.toLowerCase() === 'tak');
        setAvailableSpots(MAX_SPOTS - confirmed.length);

        const podgrupy = ['Alfa', 'Bravo', 'Charlie', 'Delta', 'Echo', 'Foxtrot', 'Golf', 'Hotel', 'India', 'Juliett', 'Kilo', 'Lima'];
        const istniejace = confirmed.map(row => row.Podgrupa).filter(Boolean);
        const nowa = podgrupy.find(p => !istniejace.includes(p)) || `Podgrupa${istniejace.length + 1}`;
        setSubgroupName(nowa);
      })
      .catch(() => setAvailableSpots('?'));
  }, []);

  const handleFormChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handlePersonChange = (index, field, value) => {
    const updated = [...additionalPeople];
    updated[index][field] = value;
    setAdditionalPeople(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // WALIDACJA ZGÓD
    if (!consentBoth) {
      toast.error('Zaznacz zgodę: RODO i Polityka prywatności.');
      return;
    }
    if (!campRulesConsent) {
      toast.error('Zaznacz akceptację Regulaminu Organizacji Obozu.');
      return;
    }
    if (!participantRulesConsent) {
      toast.error('Zaznacz akceptację Regulaminu Uczestnika.');
      return;
    }

    const timestamp = new Date().toLocaleString('pl-PL');

    let groupName = 'Grupa Wilk';
    try {
      const res = await fetch('https://opensheet.elk.sh/1zJYzeNrKT_oJCYoDpNzFyXNFnShthQISmrgNakNoFtU/Zgloszenia');
      const data = await res.json();
      const confirmedCount = data.filter(row => row.Potwierdzony?.toLowerCase() === 'tak').length;
      const groupNames = ['Grupa Wilk', 'Grupa Jastrząb', 'Grupa Lis', 'Grupa Ryś', 'Grupa Niedźwiedź'];
      groupName = groupNames[Math.floor(confirmedCount / 12)] || `Grupa ${Math.floor(confirmedCount / 12) + 1}`;
      setAssignedGroup(groupName);
    } catch (err) {
      console.error('Błąd odczytu grupy:', err);
    }

    const osoby = [
      {
        imieNazwisko: formData.name,
        wiek: formData.age,
        rola: "Zgłaszający",
        email: formData.email,
        telefon: formData.phone
      },
      ...additionalPeople.map((p, i) => ({
        imieNazwisko: p.name || `Osoba ${i + 1}`,
        wiek: p.age || '',
        rola: "Dodatkowa osoba",
        email: formData.email,
        telefon: formData.phone
      }))
    ];

    const payload = {
      grupa: groupName,
      podgrupa: subgroupName,
      osoby,
      potwierdzony: 'Nie',
      dataZgloszenia: timestamp,
      // Zgody:
      rodo_consent: consentBoth ? 'Tak' : 'Nie',
      privacy_consent: consentBoth ? 'Tak' : 'Nie',
      consent_both: consentBoth ? 'Tak' : 'Nie',
      camp_rules_consent: campRulesConsent ? 'Tak' : 'Nie',
      participant_rules_consent: participantRulesConsent ? 'Tak' : 'Nie',
    };

    try {
      await axios.post("https://form-proxy.kontakt-przetrwajto.workers.dev", payload, {
        headers: { "Content-Type": "application/json" },
      });

      await emailjs.send(
        'service_nuhju2n',
        'template_qpikvgk',
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          option: formData.option,
          message: formData.message,
          rodo_consent: consentBoth ? 'Tak' : 'Nie',
          privacy_consent: consentBoth ? 'Tak' : 'Nie',
          camp_rules_consent: campRulesConsent ? 'Tak' : 'Nie',
          participant_rules_consent: participantRulesConsent ? 'Tak' : 'Nie',
          grupa: groupName,
          podgrupa: subgroupName,
        },
        'UDBMcnzLOk_u8unmJ'
      );

      toast.success(`✅ Grupa: ${groupName} / Podgrupa: ${subgroupName}`);

      setFormData({ name: '', age: '', email: '', phone: '', option: '', confirmed: 'Nie' });
      setPersonCount(1);
      setAdditionalPeople([]);
      setConsentBoth(false);
      setCampRulesConsent(false);
      setParticipantRulesConsent(false);
    } catch (err) {
      console.error('Błąd wysyłki:', err);
      toast.error('❌ Błąd wysyłki: ' + err.message);
    }
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-6 rounded shadow">
      <form onSubmit={handleSubmit} className="grid gap-4">
        <input type="text" name="name" placeholder="Imię i nazwisko osoby zgłaszającej" value={formData.name} onChange={handleFormChange} className="p-3 border border-gray-300 rounded" required />
        <input type="number" name="age" placeholder="Wiek osoby zgłaszającej" value={formData.age} onChange={handleFormChange} className="p-3 border border-gray-300 rounded" required />
        <input type="email" name="email" placeholder="Adres e-mail" value={formData.email} onChange={handleFormChange} className="p-3 border border-gray-300 rounded" required />
        <input type="tel" name="phone" placeholder="Numer telefonu" value={formData.phone} onChange={handleFormChange} className="p-3 border border-gray-300 rounded" />

        <select name="option" value={formData.option} onChange={handleFormChange} className="p-3 border border-gray-300 rounded" required>
          <option value="">Wybierz wersję obozu</option>
          <option value="Dorosły + dziecko">Dorosły + dziecko</option>
          <option value="Tylko dorosły">Tylko dorosły</option>
        </select>

        <label className="mt-2 font-medium">Ile osób zgłaszasz (łącznie z Tobą)?</label>
        <input
          type="number"
          min="1"
          max="12"
          value={personCount}
          onChange={(e) => {
            const raw = parseInt(e.target.value || '1', 10);
            const count = Math.max(1, Math.min(12, isNaN(raw) ? 1 : raw));
            setPersonCount(count);
            setAdditionalPeople(Array.from({ length: Math.max(0, count - 1) }, (_, i) => additionalPeople[i] || { name: '', age: '' }));
          }}
          className="p-3 border border-gray-300 rounded"
          required
        />

        {additionalPeople.map((person, index) => (
          <div key={index} className="border rounded p-3 bg-gray-50">
            <h4 className="font-semibold mb-2">Osoba {index + 2}</h4>
            <input
              type="text"
              placeholder="Imię i nazwisko"
              value={person.name}
              onChange={(e) => handlePersonChange(index, 'name', e.target.value)}
              className="p-2 border border-gray-300 rounded w-full mb-2"
              required
            />
            <input
              type="number"
              placeholder="Wiek"
              value={person.age}
              onChange={(e) => handlePersonChange(index, 'age', e.target.value)}
              className="p-2 border border-gray-300 rounded w-full"
              required
            />
          </div>
        ))}

        {/* Jedna zgoda (RODO+Polityka) */}
        <label className="flex items-start gap-3 text-sm text-gray-700">
          <input
            id="consent_both_checkbox"
            name="consent_both"
            type="checkbox"
            required
            checked={consentBoth}
            onChange={(e) => setConsentBoth(e.target.checked)}
            className="mt-1 h-4 w-4"
          />
          <span>
            Akceptuję{' '}
            <button type="button" onClick={() => setShowRodoModal(true)} className="underline text-[#4c6b2d] hover:text-[#5a7d35]">
              Informację RODO
            </button>{' '}
            oraz{' '}
            <button type="button" onClick={() => setShowPrivacyModal(true)} className="underline text-[#4c6b2d] hover:text-[#5a7d35]">
              Politykę prywatności
            </button>
            .
          </span>
        </label>

        {/* Zgoda: Regulamin Organizacji Obozu */}
        <label className="flex items-start gap-3 text-sm text-gray-700 -mt-1">
          <input
            id="camp_rules_checkbox"
            name="camp_rules_consent"
            type="checkbox"
            required
            checked={campRulesConsent}
            onChange={(e) => setCampRulesConsent(e.target.checked)}
            className="mt-1 h-4 w-4"
          />
          <span>
            Akceptuję{' '}
            <button type="button" onClick={() => setShowCampRulesModal(true)} className="underline text-[#4c6b2d] hover:text-[#5a7d35]">
              Regulamin Organizacji Obozu
            </button>
            .
          </span>
        </label>

        {/* Zgoda: Regulamin Uczestnika */}
        <label className="flex items-start gap-3 text-sm text-gray-700 -mt-1">
          <input
            id="participant_rules_checkbox"
            name="participant_rules_consent"
            type="checkbox"
            required
            checked={participantRulesConsent}
            onChange={(e) => setParticipantRulesConsent(e.target.checked)}
            className="mt-1 h-4 w-4"
          />
          <span>
            Akceptuję{' '}
            <button type="button" onClick={() => setShowParticipantRulesModal(true)} className="underline text-[#4c6b2d] hover:text-[#5a7d35]">
              Regulamin Uczestnika
            </button>
            .
          </span>
        </label>

        <button
          type="submit"
          className="w-full bg-[#4c6b2d] hover:bg-[#5a7d35] text-white font-bold px-8 py-4 rounded-md text-lg shadow-lg tracking-wide uppercase transition duration-300"
        >
          Wyślij zgłoszenie
        </button>

        {assignedGroup && (
          <div className="text-center mt-6 text-[#3e4b28] font-bold text-lg tracking-wide bg-[#e6f0d5] py-2 rounded shadow-sm">
            ✅ Przydzielono do grupy: {assignedGroup}
          </div>
        )}
        {availableSpots !== null && (
          <div className="text-center mt-3 text-[#2f3d1b] font-semibold text-base bg-[#f4f4f4] py-2 rounded">
            🏕️ Pozostało miejsc: {availableSpots}
          </div>
        )}
        {subgroupName && (
          <div className="text-center mt-3 text-[#3e4b28] font-semibold text-base bg-[#e6f0d5] py-2 rounded shadow-sm">
            🔰 Twoja podgrupa: {subgroupName}
          </div>
        )}
      </form>

      {/* === MODAL: RODO === */}
      {showRodoModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center">
          <div className="absolute inset-0 bg-black/70" onClick={() => setShowRodoModal(false)} />
          <div className="relative bg-[#0f1011] text-gray-100 w-[95vw] max-w-3xl max-h-[85vh] rounded-2xl border border-[#88cc00]/30 shadow-2xl overflow-hidden">
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#88cc00]/20">
              <h3 className="text-xl font-bold text-[#b9ff3c]">Klauzula informacyjna RODO – obóz survivalowy „PrzetrwajTo”</h3>
              <button className="text-gray-300 hover:text-white text-2xl leading-none" onClick={() => setShowRodoModal(false)} aria-label="Zamknij">×</button>
            </div>
            <div className="px-6 py-6 text-gray-200 text-sm leading-relaxed max-h-[65vh] overflow-y-auto space-y-4">
              <p>Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO) informujemy, że:</p>
              <ol className="list-decimal pl-5 space-y-3">
                <li>
                  <span className="font-semibold text-white">Administrator danych:</span> Administratorem danych osobowych jest Stowarzyszenie Bonum Publicum, z siedzibą przy ul. 1 Maja 191, 25-646 Kielce.
                </li>
                <li>
                  <span className="font-semibold text-white">Cele przetwarzania:</span> Dane przetwarzane będą w celu organizacji i realizacji obozu survivalowego „PrzetrwajTo”, zapewnienia bezpieczeństwa i opieki medycznej, kontaktu z rodzicami/opiekunami, prowadzenia dokumentacji organizacyjnej i księgowej oraz – w przypadku wyrażenia dodatkowej zgody – w celach promocyjnych (publikacja zdjęć/wizerunku).
                </li>
                <li>
                  <span className="font-semibold text-white">Podstawa prawna:</span> art. 6 ust. 1 lit. a, c i f RODO.
                </li>
                <li>
                  <span className="font-semibold text-white">Odbiorcy danych:</span> Dane mogą być udostępniane kadrze obozowej, służbom medycznym, a także podmiotom uprawnionym na podstawie przepisów prawa.
                </li>
                <li>
                  <span className="font-semibold text-white">Okres przechowywania:</span> Dane będą przechowywane przez okres trwania obozu oraz wymagany przepisami prawa.
                </li>
                <li>
                  <span className="font-semibold text-white">Prawa osoby, której dane dotyczą:</span> dostęp do danych, sprostowanie, usunięcie, ograniczenie przetwarzania, przenoszenie danych, cofnięcie zgody w dowolnym momencie, wniesienie skargi do Prezesa UODO.
                </li>
                <li>
                  <span className="font-semibold text-white">Dobrowolność podania danych:</span> Podanie danych jest dobrowolne, ale niezbędne do udziału w obozie. Brak zgody uniemożliwi uczestnictwo.
                </li>
              </ol>
            </div>
            <div className="px-6 py-4 border-t border-[#88cc00]/20 flex justify-end">
              <button className="px-5 py-2 rounded-lg bg-[#4c6b2d] hover:bg-[#5a7d35] text-white font-semibold" onClick={() => setShowRodoModal(false)}>Zamknij</button>
            </div>
          </div>
        </div>
      )}

      {/* === MODAL: Polityka prywatności === */}
      {showPrivacyModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center">
          <div className="absolute inset-0 bg-black/70" onClick={() => setShowPrivacyModal(false)} />
          <div className="relative bg-[#0f1011] text-gray-100 w-[95vw] max-w-3xl max-h-[85vh] rounded-2xl border border-[#88cc00]/30 shadow-2xl overflow-hidden">
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#88cc00]/20">
              <h3 className="text-xl font-bold text-[#b9ff3c]">Polityka Prywatności – „PrzetrwajTo”</h3>
              <button className="text-gray-300 hover:text-white text-2xl leading-none" onClick={() => setShowPrivacyModal(false)} aria-label="Zamknij">×</button>
            </div>
            <div className="px-6 py-6 text-gray-200 text-sm leading-relaxed max-h-[65vh] overflow-y-auto space-y-6">
              <section>
                <h4 className="font-semibold text-white">1. Administrator danych osobowych</h4>
                <p>
                  Administratorem danych osobowych jest Stowarzyszenie Bonum Publicum z siedzibą przy ul. 1 Maja 191, 25-646 Kielce.
                  <br />
                  Kontakt z administratorem danych osobowych możliwy jest pod adresem e-mail: <strong>kontakt@przetrwajto.pl</strong>.
                </p>
              </section>

              <section>
                <h4 className="font-semibold text-white">2. Zakres gromadzonych danych</h4>
                <ul className="list-disc pl-5 space-y-1">
                  <li>dane zgłaszającego: imię, nazwisko, wiek, adres e-mail, numer telefonu;</li>
                  <li>dane uczestników: imię, nazwisko, wiek;</li>
                  <li>dane dodatkowe: liczba osób, preferencje dotyczące uczestnictwa, dane zdrowotne (jeśli podane dobrowolnie), wizerunek (jeśli wyrażono zgodę na publikację zdjęć);</li>
                  <li>dane techniczne: adres IP, informacje o przeglądarce, dane zbierane automatycznie przez pliki cookies.</li>
                </ul>
              </section>

              <section>
                <h4 className="font-semibold text-white">3. Cele i podstawy prawne przetwarzania danych</h4>
                <table className="w-full text-sm border border-gray-600">
                  <thead>
                    <tr className="bg-gray-700">
                      <th className="text-left p-2 border border-gray-600">Cel</th>
                      <th className="text-left p-2 border border-gray-600">Podstawa prawna</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="bg-gray-800">
                      <td className="p-2 border border-gray-700">Rejestracja uczestnictwa w obozie</td>
                      <td className="p-2 border border-gray-700">art. 6 ust. 1 lit. b RODO</td>
                    </tr>
                    <tr className="bg-gray-800/70">
                      <td className="p-2 border border-gray-700">Zapewnienie bezpieczeństwa, zdrowia i opieki</td>
                      <td className="p-2 border border-gray-700">art. 6 ust. 1 lit. c i d RODO</td>
                    </tr>
                    <tr className="bg-gray-800">
                      <td className="p-2 border border-gray-700">Kontakt organizacyjny</td>
                      <td className="p-2 border border-gray-700">art. 6 ust. 1 lit. f RODO</td>
                    </tr>
                    <tr className="bg-gray-800/70">
                      <td className="p-2 border border-gray-700">Prowadzenie dokumentacji księgowej</td>
                      <td className="p-2 border border-gray-700">art. 6 ust. 1 lit. c RODO</td>
                    </tr>
                    <tr className="bg-gray-800">
                      <td className="p-2 border border-gray-700">Promocja (publikacja zdjęć i wizerunku)</td>
                      <td className="p-2 border border-gray-700">art. 6 ust. 1 lit. a RODO – zgoda</td>
                    </tr>
                    <tr className="bg-gray-800/70">
                      <td className="p-2 border border-gray-700">Marketing i statystyka strony</td>
                      <td className="p-2 border border-gray-700">art. 6 ust. 1 lit. f RODO</td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section>
                <h4 className="font-semibold text-white">4. Czas przechowywania danych</h4>
                <ul className="list-disc pl-5 space-y-1">
                  <li>przez czas niezbędny do realizacji obozu oraz do celów dokumentacyjnych i sprawozdawczych – maksymalnie 5 lat od zakończenia wydarzenia;</li>
                  <li>dane zawarte na fakturach i dokumentach księgowych – przez okres wymagany przepisami prawa;</li>
                  <li>dane przetwarzane na podstawie zgody – do momentu jej cofnięcia.</li>
                </ul>
              </section>

              <section>
                <h4 className="font-semibold text-white">5. Odbiorcy danych</h4>
                <ul className="list-disc pl-5 space-y-1">
                  <li>uprawnieni członkowie kadry organizacyjnej i instruktorzy;</li>
                  <li>podmioty realizujące usługi na zlecenie organizatora (np. ubezpieczyciele, dostawcy usług IT, hostingodawcy);</li>
                  <li>służby medyczne i ratownicze w sytuacjach nagłych;</li>
                  <li>organy administracji publicznej – jeśli wynika to z przepisów prawa.</li>
                </ul>
              </section>

              <section>
                <h4 className="font-semibold text-white">6. Prawa osób, których dane dotyczą</h4>
                <ul className="list-disc pl-5 space-y-1">
                  <li>dostępu do danych osobowych,</li>
                  <li>sprostowania, usunięcia lub ograniczenia przetwarzania,</li>
                  <li>przenoszenia danych,</li>
                  <li>sprzeciwu wobec przetwarzania danych,</li>
                  <li>cofnięcia zgody w dowolnym momencie (jeśli podstawą był art. 6 ust. 1 lit. a RODO),</li>
                  <li>wniesienia skargi do Prezesa UODO.</li>
                </ul>
              </section>

              <section>
                <h4 className="font-semibold text-white">7. Pliki cookies</h4>
                <p>Strona korzysta z plików cookies w celu zapewnienia prawidłowego działania serwisu, analizy ruchu oraz funkcji społecznościowych. Możesz je wyłączyć w ustawieniach przeglądarki; może to jednak wpłynąć na działanie części serwisu.</p>
              </section>

              <section>
                <h4 className="font-semibold text-white">8. Zabezpieczenie danych</h4>
                <p>Dane przetwarzamy z zachowaniem odpowiednich środków bezpieczeństwa. Wdrożyliśmy polityki zapewniające poufność, integralność i dostępność danych.</p>
              </section>

              <section>
                <h4 className="font-semibold text-white">9. Dobrowolność podania danych</h4>
                <p>Podanie danych jest dobrowolne, jednak ich brak uniemożliwia udział w wydarzeniach organizowanych przez Stowarzyszenie Bonum Publicum.</p>
              </section>

              <section>
                <h4 className="font-semibold text-white">10. Zmiany Polityki Prywatności</h4>
                <p>Zastrzegamy sobie prawo do aktualizacji niniejszej Polityki Prywatności. Aktualna wersja będzie publikowana na stronie internetowej.</p>
              </section>
            </div>
            <div className="px-6 py-4 border-t border-[#88cc00]/20 flex justify-end">
              <button className="px-5 py-2 rounded-lg bg-[#4c6b2d] hover:bg-[#5a7d35] text-white font-semibold" onClick={() => setShowPrivacyModal(false)}>Zamknij</button>
            </div>
          </div>
        </div>
      )}

      {/* === MODAL: Regulamin Organizacji Obozu === */}
      {showCampRulesModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center">
          <div className="absolute inset-0 bg-black/70" onClick={() => setShowCampRulesModal(false)} />
          <div className="relative bg-[#0f1011] text-gray-100 w-[95vw] max-w-3xl max-h-[85vh] rounded-2xl border border-[#88cc00]/30 shadow-2xl overflow-hidden">
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#88cc00]/20">
              <h3 className="text-xl font-bold text-[#b9ff3c]">Regulamin Organizacji Obozu Survivalowego „PrzetrwajTo”</h3>
              <button className="text-gray-300 hover:text-white text-2xl leading-none" onClick={() => setShowCampRulesModal(false)} aria-label="Zamknij">×</button>
            </div>
            <div className="px-6 py-6 text-gray-200 text-sm leading-relaxed max-h-[65vh] overflow-y-auto space-y-5">
              <p><em>Uwaga: Uzupełnieniem niniejszego regulaminu są Informacje Organizacyjne, przesyłane uczestnikom po dokonaniu rezerwacji.</em></p>
              <hr className="border-[#88cc00]/20" />
              <ol className="list-decimal pl-5 space-y-4">
                <li>
                  <span className="font-semibold text-white">ORGANIZATOR</span>
                  <p>Organizatorem obozów survivalowych „PrzetrwajTo” jest Stowarzyszenie Bonum Publicum, z siedzibą przy ul. 1 Maja 191, 25-646 Kielce, wpisana do rejestru KRS. Kontakt do organizatora znajduje się na stronie internetowej <strong>www.przetrwajto.pl</strong> oraz w wiadomościach e-mail przesyłanych uczestnikom.</p>
                </li>
                <li>
                  <span className="font-semibold text-white">REZERWACJA MIEJSCA</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Rezerwacji miejsca dokonuje się poprzez formularz zgłoszeniowy udostępniony na stronie internetowej.</li>
                    <li>Warunkiem potwierdzenia rezerwacji jest dokonanie wpłaty zaliczki w wysokości wskazanej w cenniku, w terminie 7 dni od przesłania formularza.</li>
                    <li>Rezerwacje nieopłacone w podanym terminie mogą zostać automatycznie anulowane.</li>
                    <li>Miejsca przydzielane są według kolejności zaksięgowanych wpłat.</li>
                    <li>W uzasadnionych przypadkach organizator zastrzega sobie możliwość zmiany przypisania uczestnika do grupy (np. ze względu na wiek, doświadczenie lub bezpieczeństwo).</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">KARTA KWALIFIKACYJNA</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Każdy uczestnik (lub jego rodzic/opiekun prawny w przypadku osób niepełnoletnich) zobowiązany jest do wypełnienia i dostarczenia Karty Kwalifikacyjnej Uczestnika.</li>
                    <li>Formularz generowany jest automatycznie po dokonaniu rezerwacji i przesyłany drogą mailową.</li>
                    <li>Karta musi być wydrukowana i podpisana przez uprawnione osoby. Niedozwolone są ręczne poprawki – ewentualne zmiany należy wprowadzić elektronicznie poprzez formularz on-line i ponownie wydrukować dokument.</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">STAN ZDROWIA, DIETA I BEZPIECZEŃSTWO</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Uczestnicy zobowiązani są do poinformowania organizatora o wszelkich istotnych kwestiach zdrowotnych (choroby przewlekłe, alergie, urazy, przeciwwskazania do wysiłku fizycznego) oraz o specjalnych potrzebach dietetycznych.</li>
                    <li>Informacje te należy podać najpóźniej 7 dni od dokonania rezerwacji, korzystając z formularza on-line.</li>
                    <li>Organizator zastrzega sobie prawo odmowy udziału uczestnika, którego stan zdrowia uniemożliwia bezpieczny udział w obozie.</li>
                    <li>Obóz survivalowy obejmuje wzmożoną aktywność fizyczną i zajęcia terenowe – każdy uczestnik bierze w nich udział na własną odpowiedzialność (w przypadku niepełnoletnich – na odpowiedzialność rodzica/opiekuna prawnego).</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">PŁATNOŚCI</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Pierwszą wpłatę (zaliczkę) należy uiścić przy rezerwacji.</li>
                    <li>Pozostałą część kwoty należy wpłacić przelewem najpóźniej 21 dni przed rozpoczęciem obozu.</li>
                    <li>Dane do przelewu przesyłane są w wiadomości potwierdzającej zgłoszenie.</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">REZYGNACJA Z UCZESTNICTWA</span>
                  <p className="mt-2">W przypadku rezygnacji uczestnika z udziału w obozie, zwrot wpłaconych środków następuje po potrąceniu kosztów poniesionych przez organizatora:</p>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>powyżej 60 dni przed obozem – potrącenie 30% ceny,</li>
                    <li>60–30 dni przed obozem – potrącenie 50% ceny,</li>
                    <li>30–14 dni przed obozem – potrącenie 75% ceny,</li>
                    <li>poniżej 14 dni przed obozem – potrącenie 90% ceny.</li>
                  </ul>
                </li>
                <li>
                  <span className="font-semibold text-white">UBEZPIECZENIE</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Organizator zapewnia każdemu uczestnikowi ubezpieczenie NNW (następstw nieszczęśliwych wypadków).</li>
                    <li>Kadra obozowa objęta jest dodatkowo ubezpieczeniem OC (odpowiedzialności cywilnej).</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">REGULAMIN UCZESTNIKA</span>
                  <p className="mt-2">Integralną częścią niniejszego regulaminu jest Regulamin Uczestnika Obozu Survivalowego, którego przestrzeganie jest obowiązkowe.</p>
                </li>
                <li>
                  <span className="font-semibold text-white">KONTAKT Z RODZICAMI/OPIEKUNAMI</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Uczestnicy mogą zabrać na obóz własne telefony komórkowe, jednak ich używanie będzie ograniczone – nie będą mogli korzystać z telefonów podczas zajęć programowych, zadań terenowych i aktywności grupowych.</li>
                    <li>Organizator wyznacza określone godziny kontaktu telefonicznego, w czasie których uczestnicy będą mogli korzystać ze swoich telefonów.</li>
                    <li>Przed rozpoczęciem obozu rodzice/opiekunowie otrzymają numer telefonu do kierownika placówki oraz organizatora, a także informację o godzinach dostępności kontaktowej.</li>
                    <li>W sprawach organizacyjnych oraz nagłych, zaleca się kontakt wyłącznie z kadrą organizacyjną, a nie bezpośrednio z uczestnikami – w celu zapewnienia płynności realizacji programu i bezpieczeństwa grupy..</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">DANE OSOBOWE</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Organizator przetwarza dane osobowe uczestników zgodnie z obowiązującymi przepisami prawa oraz własną polityką prywatności.</li>
                    <li>Dane uczestników wykorzystywane są wyłącznie w celu realizacji procesu rezerwacji, organizacji obozu oraz zapewnienia bezpieczeństwa uczestników.</li>
                  </ol>
                </li>
              </ol>
            </div>
            <div className="px-6 py-4 border-t border-[#88cc00]/20 flex justify-end">
              <button className="px-5 py-2 rounded-lg bg-[#4c6b2d] hover:bg-[#5a7d35] text-white font-semibold" onClick={() => setShowCampRulesModal(false)}>Zamknij</button>
            </div>
          </div>
        </div>
      )}

      {/* === MODAL: Regulamin Uczestnika === */}
      {showParticipantRulesModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center">
          <div className="absolute inset-0 bg-black/70" onClick={() => setShowParticipantRulesModal(false)} />
          <div className="relative bg-[#0f1011] text-gray-100 w-[95vw] max-w-3xl max-h-[85vh] rounded-2xl border border-[#88cc00]/30 shadow-2xl overflow-hidden">
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#88cc00]/20">
              <h3 className="text-xl font-bold text-[#b9ff3c]">Regulamin Uczestnika Obozu Survivalowego „PrzetrwajTo”</h3>
              <button className="text-gray-300 hover:text-white text-2xl leading-none" onClick={() => setShowParticipantRulesModal(false)} aria-label="Zamknij">×</button>
            </div>
            <div className="px-6 py-6 text-gray-200 text-sm leading-relaxed max-h-[65vh] overflow-y-auto space-y-5">
              <p>Regulamin ma na celu zapewnienie bezpieczeństwa, dobrej atmosfery i sprawnego przebiegu obozu survivalowego. Każdy uczestnik zobowiązany jest do jego przestrzegania.</p>
              <hr className="border-[#88cc00]/20" />
              <ol className="list-decimal pl-5 space-y-4">
                <li>
                  <span className="font-semibold text-white">UCZESTNICTWO I BEZPIECZEŃSTWO</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Uczestnicy biorą udział w zajęciach zgodnie z programem przygotowanym przez kadrę.</li>
                    <li>Obowiązuje bezwzględne podporządkowanie się poleceniom instruktorów i wychowawców, szczególnie w sytuacjach dotyczących bezpieczeństwa.</li>
                    <li>Zabrania się samowolnego oddalania się od grupy lub opuszczania terenu obozu bez zgody kadry.</li>
                    <li>Uczestnicy zobowiązani są do przestrzegania zasad bezpieczeństwa podczas zajęć terenowych, ćwiczeń survivalowych, ognisk, wędrówek oraz zajęć ze sprzętem.</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">ZASADY WSPÓŁŻYCIA OBOZOWEGO</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Każdy uczestnik zobowiązany jest do okazywania szacunku innym uczestnikom oraz kadrze.</li>
                    <li>Niedopuszczalne są wszelkie formy przemocy fizycznej, słownej lub psychicznej.</li>
                    <li>Od uczestników oczekuje się współpracy, wzajemnej pomocy i koleżeńskiej postawy – survival opiera się na pracy zespołowej.</li>
                    <li>Obowiązuje dbanie o wspólne wyposażenie, sprzęt obozowy oraz porządek w miejscu zakwaterowania.</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">ZDROWIE I HIGIENA</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Uczestnicy zobowiązani są do dbania o higienę osobistą oraz utrzymywania czystości w obozie.</li>
                    <li>Każdy problem zdrowotny (np. złe samopoczucie, uraz, alergia) należy natychmiast zgłosić kadrze.</li>
                    <li>Samodzielne przyjmowanie leków przez uczestników niepełnoletnich jest zabronione – lekarstwa przechowywane są u wychowawców i wydawane zgodnie ze wskazaniami.</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">ZAKAZY</span>
                  <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>posiadania i używania alkoholu, papierosów, e-papierosów, narkotyków i innych substancji psychoaktywnych,</li>
                    <li>używania ostrych narzędzi i sprzętu survivalowego bez nadzoru instruktora,</li>
                    <li>niszczenia przyrody – obowiązuje zasada „Leave No Trace” (pozostawiania miejsca w lepszym stanie, niż je zastaliśmy),</li>
                    <li>korzystania z urządzeń elektronicznych w trakcie trwania zajęć programowych, zadań terenowych i aktywności grupowych</li>
                    <li>wnoszenia broni, petard, fajerwerków i innych materiałów niebezpiecznych.</li>
                  </ul>
                </li>
                <li>
                  <span className="font-semibold text-white">OBOWIĄZKI UCZESTNIKA</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Uczestnik zobowiązany jest do aktywnego udziału w zajęciach oraz współpracy z grupą.</li>
                    <li>Każdy uczestnik ma obowiązek poszanowania zasad ekologii i ochrony przyrody.</li>
                    <li>Należy dbać o powierzony sprzęt (np. noże, siekiery, piły, namioty, liny, plecaki) – w przypadku umyślnego zniszczenia uczestnik (lub jego opiekun) ponosi odpowiedzialność materialną.</li>
                    <li>Uczestnik zobowiązany jest do terminowego stawiania się na zbiórkach i zajęciach.</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">KONSEKWENCJE NARUSZEŃ</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Uczestnik, który nie stosuje się do regulaminu lub poleceń kadry, może otrzymać:
                      <ul className="list-disc pl-5 mt-1 space-y-1">
                        <li>upomnienie ustne,</li>
                        <li>ograniczenie udziału w wybranych zajęciach,</li>
                        <li>informację do rodziców/opiekunów.</li>
                      </ul>
                    </li>
                    <li>W przypadku poważnego lub powtarzającego się naruszenia regulaminu organizator zastrzega sobie prawo do wydalenia uczestnika z obozu na koszt rodziców/opiekunów.</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">KONTAKT Z RODZICAMI</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Uczestnicy mogą posiadać własne telefony komórkowe, jednak ich używanie jest niedozwolone podczas zajęć programowych, aktywności terenowych oraz czasu wspólnego.</li>
                    <li>Kontakt z rodzicami/opiekunami odbywa się wyłącznie w wyznaczonych godzinach</li>
                  </ol>
                </li>
                <li>
                  <span className="font-semibold text-white">POSTANOWIENIA KOŃCOWE</span>
                  <ol className="list-decimal pl-5 mt-2 space-y-1">
                    <li>Regulamin wchodzi w życie z dniem rozpoczęcia obozu i obowiązuje przez cały czas jego trwania.</li>
                    <li>Zgłoszenie na obóz oznacza akceptację niniejszego regulaminu.</li>
                    <li>Regulamin ma na celu wspólne bezpieczeństwo i jak najlepsze przeżycie obozowej przygody.</li>
                  </ol>
                </li>
              </ol>
            </div>
            <div className="px-6 py-4 border-t border-[#88cc00]/20 flex justify-end">
              <button className="px-5 py-2 rounded-lg bg-[#4c6b2d] hover:bg-[#5a7d35] text-white font-semibold" onClick={() => setShowParticipantRulesModal(false)}>Zamknij</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignupForm;
